<template>
<div>
  <el-button v-if="isShowBtn" style="width:100%;" type="primary" size="small" @click="open">스냅샷</el-button>
  <w-sliding-popup ref="slidingPopup" title="스냅샷 관리" top="50px" width="800px" @close="close">
    <div slot="content">
      <el-row v-if="!isEditMode" :gutter="15">
        <el-col :span="10">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="title-h4">스냅샷 리스트</div>
            <div>
              <el-button type="secondary" @click="loadData">새로고침</el-button>
              <el-button type="secondary" @click="onEditButtonClick('CREATE')">생성</el-button>
            </div>
          </el-row>
          <div class="snapshot-tree-wrapper" v-loading="isLoading">
            <el-tree
              :default-expand-all="true"
              ref= "treeRef"
              :data="treeData"
              :props="defaultProps"
              :node-key="defaultProps.treeKey"
              :highlight-current="true"
              :expand-on-click-node="false"
              @node-click="onNodeClick"
              >
            </el-tree>
          </div>
        </el-col>
        <el-col :span="14">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="title-h4">스냅샷 상세정보</div>
            <div>
              <el-button type="secondary" :disabled="etcBtnDisabled" @click="onExecuteButtonClick('REVERT')">복원</el-button>
              <el-button type="secondary" :disabled="etcBtnDisabled" @click="onEditButtonClick('UPDATE')">편집</el-button>
              <el-button type="secondary" :disabled="etcBtnDisabled" @click="onExecuteButtonClick('DELETE')">삭제</el-button>
            </div>
          </el-row>
          <div class="list form-list">
            <el-form :model="formData" ref="snapshotInfoForm" label-position="left" label-width="80px" >
              <el-form-item label="이름">
                {{ formData.name }}
              </el-form-item>
              <el-form-item label="설명">
                {{ formData.desc }}
              </el-form-item>
              <el-form-item label="생성일">
                {{ getDate }}
              </el-form-item>
              <el-form-item label="스냅샷 크기">
                {{ getConvertValue }}
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-form :model="editFormData" :rules="rules" ref="editForm" label-width="120px" label-position="top">
          <el-form-item label="이름" prop="name">
            <el-input v-model="editFormData.name"></el-input>
          </el-form-item>
          <el-form-item label="설명" prop="desc">
            <el-input type="textarea" :rows="5" v-model="editFormData.desc"></el-input>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <div slot="footer">
      <el-button v-if="isEditMode" type="solid" size="large" @click="onSaveButtonClick">저장</el-button>
      <el-button v-if="isEditMode" size="large" @click="onCancelEdit">취소</el-button>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import clone from 'lodash/clone';
import commonApi from '@/api/virtual/performance/common';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import { convertValuByUnit } from '@/utils/number';
import { isEmpty } from '@/utils/basic';

export default {
  name: 'WVirtualSnapShotPopup',
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
    isShowBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      reqType: {
        CREATE: '생성',
        DELETE: '삭제',
        UPDATE: '편집',
        REVERT: '복원',
      },
      isLoading: true,
      treeData: [],
      formData: {
        type: 'VVM',
      },
      isEditMode: false,
      defaultProps: {
        treeKey: 'name',
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      editFormData: {
        name: '',
        desc: '',
      },
      rules: {
        name: [
          {
            required: true,
            message: '이름을 입력해주십시오.',
            trigger: 'change',
          },
        ],
      },
    };
  },
  computed: {
    getDate() {
      return isEmpty(this.formData.createDateTime) ? '' : getDateToString(this.formData.createDateTime);
    },
    getConvertValue() {
      return convertValuByUnit(this.formData.size);
    },
    etcBtnDisabled() {
      return this.formData.type === 'VVM' || this.formData.type === 'CURRENT';
    },
  },
  methods: {
    loadData() {
      this.formData = {};
      this.onCancelEdit();
      this.isLoading = true;
      if (!isEmpty(this.objInfo)) {
        commonApi.getVmsSnapshoDetailInfo(this.objInfo.obj.objId).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            this.treeData = response.data.data;
            this.formData = response.data.data[0];
          }
          this.isLoading = false;
        });
      }
    },
    onNodeClick(data) {
      this.formData = data;
    },
    onEditButtonClick(editType) {
      if (editType === 'UPDATE' && isEmpty(this.formData.snapshotID)) {
        this.$message(msgUtil.getCustomResultMsgData('스냅샷을 선택해주십시오.', false));
        return;
      }

      this.isEditMode = true;
      if (editType === 'UPDATE') {
        this.editFormData = clone(this.formData);
      }
      this.editFormData.editType = editType;
    },
    onExecuteButtonClick(reqType) {
      if (isEmpty(this.formData.snapshotID)) {
        this.$message(msgUtil.getCustomResultMsgData('스냅샷을 선택해주십시오.', false));
        return;
      }

      this.$confirm(...msgUtil.getCustomConfirmData(`스냅샷을 ${this.reqType[reqType]}하시겠습니까?`)).then(() => {
        const params = {
          reqType,
          objId: this.objInfo.obj.objId,
          snapshotId: this.formData.snapshotID,
        };

        this.executeSnapshot(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getCustomResultMsgData(`스냅샷 ${this.reqType[params.reqType]} 요청하였습니다.`, true));
          } else {
            this.$message(msgUtil.getCustomResultMsgData('하이퍼바이저 상태를 확인해주십시오.', false));
          }
        });
      }).catch(() => {});
    },
    onSaveButtonClick() {
      const editFormData = clone(this.editFormData);

      const params = {
        reqType: editFormData.editType,
        objId: this.objInfo.obj.objId,
        snapshotId: editFormData.snapshotID,
        snapshotName: editFormData.name,
        snapshotDesc: editFormData.desc,
      };

      this.$refs.editForm.validate().then((res) => {
        if (res) {
          this.executeSnapshot(params).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getCustomResultMsgData(`스냅샷 ${this.reqType[params.reqType]}을 요청하였습니다.`, true));
            } else {
              this.$message(msgUtil.getCustomResultMsgData('하이퍼바이저 상태를 확인해주십시오.', false));
            }
            this.onCancelEdit();
          });
        }
      }).catch(() => {});
    },
    executeSnapshot(params) {
      return commonApi.executeVmSnapshot(params);
    },
    onCancelEdit() {
      this.isEditMode = false;
      this.editFormData = {};
    },
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.onCancelEdit();
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/VirtualSnapShotPopup.vue